import chartConfigCompressor from './compress';

function getBase64urlEncoded(base64string) {
  return encodeURIComponent(base64string);
}

export default function encodeChartConfigToBase64(chartConfigOptions) {
  let compressedData = null;
  try {
    compressedData = JSON.stringify(chartConfigCompressor(chartConfigOptions));
  } catch (error) {
    compressedData = JSON.stringify(chartConfigOptions);
  }

  if (compressedData === null || !window.btoa) {
    return null;
  }

  return window.btoa(getBase64urlEncoded(compressedData));
}
